"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const modules_1 = require("@/store/modules");
const vuex_1 = require("vuex");
const constants_1 = require("@/store/modules/vehicleSelector/constants");
const vue_property_decorator_1 = require("vue-property-decorator");
const utils_1 = require("@/store/modules/vehicleSelector/utils");
const utils_2 = require("@/utils");
const core_1 = require("@workbench/core");
const types_1 = require("@/store/modules/vmds/types");
const TrackingManager_1 = require("@/utils/TrackingManager");
const vehicle_selector_body_type_vue_1 = tslib_1.__importDefault(require("@/components/vehicle-selector-body-type/vehicle-selector-body-type.vue"));
const vehicle_selector_model_vue_1 = tslib_1.__importDefault(require("@/components/vehicle-selector-model/vehicle-selector-model.vue"));
const vehicle_selector_motorization_vue_1 = tslib_1.__importDefault(require("@/components/vehicle-selector-motorization/vehicle-selector-motorization.vue"));
const vehicle_selector_navigation_vue_1 = tslib_1.__importDefault(require("@/components/vehicle-selector-navigation/vehicle-selector-navigation.vue"));
const vehicle_selector_slide_vue_1 = tslib_1.__importDefault(require("@/components/vehicle-selector-slide/vehicle-selector-slide.vue"));
const vehicle_selector_slides_vue_1 = tslib_1.__importDefault(require("@/components/vehicle-selector-slides/vehicle-selector-slides.vue"));
const vehicle_selector_title_step_vue_1 = tslib_1.__importDefault(require("@/components/vehicle-selector-title-step/vehicle-selector-title-step.vue"));
let VehicleSelectorBody = class VehicleSelectorBody extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.STEPS = constants_1.STEPS;
        this.getDefaultImage = utils_1.getDefaultImage;
        this.slidingDirection = 'left';
        this.scrollLockService = new core_1.ScrollLockService();
    }
    getPriceDescription(vehicle) {
        if (!this.defaultCustomerType) {
            return '';
        }
        const isBusiness = this.defaultCustomerType === utils_2.CUSTOMER_TYPE.BUSINESS;
        const priceTag = (0, utils_2.getValidPriceTag)(vehicle, isBusiness);
        return priceTag === 'netPrice' ? this.translate('vatExcluded') : this.translate('vatIncluded');
    }
    /**
     * @deprecated To be handled in the vehicle transformation layer
     * after VMDS refactoring
     */
    getPower(maxEngineData) {
        return maxEngineData && maxEngineData.powerInKw ? maxEngineData.powerInKw : null;
    }
    /**
     * @deprecated To be handled in the vehicle transformation layer
     * after VMDS refactoring
     */
    getPrice(vehicle) {
        const isBusiness = this.defaultCustomerType === utils_2.CUSTOMER_TYPE.BUSINESS;
        const priceTag = (0, utils_2.getValidPriceTag)(vehicle, isBusiness);
        return (0, utils_2.inputFormatting)(vehicle[priceTag], this.formatting);
    }
    getFuelType(fuelTypes) {
        const mainFuelType = fuelTypes[0];
        switch (mainFuelType) {
            case types_1.FuelType.DIESEL:
                return this.translate('diesel');
            case types_1.FuelType.PETROL:
                return this.translate('petrol');
            case types_1.FuelType.PETROL_PLUS:
                return this.translate('petrolPlus');
            case types_1.FuelType.ELECTRIC:
                return this.translate('electric');
            default:
                return (0, utils_1.formatFuelType)(mainFuelType);
        }
    }
    getTransmission(transmission) {
        switch (transmission) {
            case types_1.Transmission.AUTOMATIC:
                return this.translate('automaticTransmission');
            case types_1.Transmission.MANUAL:
                return this.translate('manualTransmission');
            default:
                return transmission;
        }
    }
    handleClassSelection(classData) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.slidingDirection = 'left';
            yield this.selectClass({
                classId: classData.classId,
                className: classData.className,
            });
            TrackingManager_1.tracking.selectOption(TrackingManager_1.SELECTOR_TYPES.CLASS, classData.classId);
            this.navigate(constants_1.STEPS.TWO_CHOOSE_BODY_TYPE);
        });
    }
    get bodyTypes() {
        return this.getBodyTypesForClass(this.selectedClass.classId);
    }
    get priceReferences() {
        var _a;
        return (_a = this.outputsConfig.priceReferences) !== null && _a !== void 0 ? _a : [];
    }
    get priceSuffix() {
        const key = 'priceSuffix';
        const translation = this.translate(key);
        return translation !== key ? ` ${translation}` : '';
    }
    get vehicles() {
        return this.getVehiclesForBodyType(this.selectedClass.classId, this.selectedBodytype.id);
    }
    get vehicleImage() {
        return this.getImageForBodyType(this.selectedClass.classId, this.selectedBodytype.id);
    }
    handleBodytypeSelection(bodyType) {
        this.slidingDirection = 'left';
        TrackingManager_1.tracking.selectOption(TrackingManager_1.SELECTOR_TYPES.BODY_TYPE, bodyType.id);
        this.selectBodyType({
            id: bodyType.id,
            name: bodyType.name,
        });
        this.navigate(constants_1.STEPS.THREE_CHOOSE_MOTORIZATION);
    }
    handleMotorizationSelection({ typeId, name }) {
        TrackingManager_1.tracking.selectOption(TrackingManager_1.SELECTOR_TYPES.MOTORISATION);
        this.selectVehicle({
            typeId,
            name,
        });
        this.toggleVehicleSelector();
    }
    navigateBack() {
        this.slidingDirection = 'right';
        this.back();
    }
    mounted() {
        if (!this.isFullscreenDisabled) {
            this.scrollLockService.lock();
        }
    }
    beforeDestroy() {
        this.$emit('close');
        if (!this.isFullscreenDisabled) {
            this.scrollLockService.unlock();
        }
    }
};
VehicleSelectorBody = tslib_1.__decorate([
    (0, vue_property_decorator_1.Component)({
        name: 'VehicleSelectorBody',
        components: {
            VehicleSelectorBodyType: vehicle_selector_body_type_vue_1.default,
            VehicleSelectorModel: vehicle_selector_model_vue_1.default,
            VehicleSelectorMotorization: vehicle_selector_motorization_vue_1.default,
            VehicleSelectorNavigation: vehicle_selector_navigation_vue_1.default,
            VehicleSelectorSlide: vehicle_selector_slide_vue_1.default,
            VehicleSelectorSlides: vehicle_selector_slides_vue_1.default,
            VehicleSelectorTitleStep: vehicle_selector_title_step_vue_1.default,
        },
        computed: Object.assign(Object.assign(Object.assign({}, (0, vuex_1.mapState)([modules_1.MODULES.VMDS])), (0, vuex_1.mapGetters)([
            'formatting',
            'translate',
            'availableClasses',
            'getAvailableClasses',
            'getBodyTypesForClass',
            'getVehiclesForBodyType',
            'defaultCustomerType',
            'getImageForBodyType',
            'outputsConfig',
        ])), (0, vuex_1.mapGetters)(modules_1.MODULES.VEHICLE_SELECTOR, [
            'currentStep',
            'selectedClass',
            'selectedBodytype',
            'selectedVehicle',
            'disableBackNavigation',
            'vehicleSelectorIsVisible',
            'isFullscreenDisabled',
        ])),
        methods: Object.assign({}, (0, vuex_1.mapActions)(modules_1.MODULES.VEHICLE_SELECTOR, [
            'back',
            'navigate',
            'selectClass',
            'selectBodyType',
            'selectVehicle',
            'toggleVehicleSelector',
        ])),
    })
], VehicleSelectorBody);
exports.default = VehicleSelectorBody;
